import React, { useState, useEffect } from 'react';
import { getMenuItems, fetchMenuItemsAsync } from '../../services/storage';

const CATEGORIES = [
    { id: 'all', label: 'Tất Cả Thức Uống' },
    { id: 'traditional', label: 'Cà Phê Phin Truyền Thống' },
    { id: 'specialty', label: 'Món Đặc Biệt (Signature)' },
    { id: 'tea_refresh', label: 'Trà & Thức Uống Khác' }
];

const Menu = () => {
    const [menuItems, setMenuItems] = useState(getMenuItems());
    const [activeCategory, setActiveCategory] = useState('all');

    const loadMenuData = async () => {
        const data = await fetchMenuItemsAsync();
        setMenuItems(data);
    };

    useEffect(() => {
        loadMenuData();

        const handleUpdate = () => {
            setMenuItems(getMenuItems());
        };

        window.addEventListener('cafe9_menu_updated', handleUpdate);
        return () => window.removeEventListener('cafe9_menu_updated', handleUpdate);
    }, []);

    // Filter available items by category
    const availableItems = menuItems.filter(item => item.isAvailable !== false);
    const filteredItems = activeCategory === 'all'
        ? availableItems
        : availableItems.filter(item => item.category === activeCategory);

    return (
        <section className="menu-section" id="menu">
            <div className="section-header">
                <span className="section-tag">Thực Đơn Đậm Vị</span>
                <h2>Khám Phá Hương Vị <span>Café 9</span></h2>
                <p>Từ những ly cà phê phin thơm nồng đến các thức uống giải khát mát lạnh ven biển.</p>
                <div className="header-divider">
                    <i className="fas fa-mug-hot"></i>
                </div>
            </div>

            {/* Category Tabs */}
            <div className="menu-categories">
                {CATEGORIES.map(category => (
                    <button
                        key={category.id}
                        className={`category-tab ${activeCategory === category.id ? 'active' : ''}`}
                        onClick={() => setActiveCategory(category.id)}
                    >
                        <span>{category.label}</span>
                    </button>
                ))}
            </div>

            {/* Menu Grid */}
            <div className="menu-grid">
                {filteredItems.map(item => (
                    <div className="menu-card" key={item.id}>
                        <div className="menu-card-image-wrap">
                            {item.image && item.image.trim() !== '' ? (
                                <img
                                    src={item.image}
                                    alt={item.name}
                                    className="menu-card-image"
                                    loading="lazy"
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                        if (e.target.parentElement) {
                                            e.target.parentElement.classList.add('has-solid-fallback');
                                        }
                                    }}
                                />
                            ) : (
                                <div className="menu-card-solid-placeholder">
                                    <div className="solid-placeholder-inner">
                                        <i className="fas fa-mug-hot"></i>
                                        <span className="solid-brand-text">Café 9</span>
                                    </div>
                                </div>
                            )}

                            {/* Badges */}
                            <div className="menu-badges">
                                {item.isBestSeller && (
                                    <span className="menu-badge badge-bestseller">
                                        <i className="fas fa-fire"></i> Best Seller
                                    </span>
                                )}
                                {item.isMustTry && (
                                    <span className="menu-badge badge-musttry">
                                        <i className="fas fa-star"></i> Khuyên Thử
                                    </span>
                                )}
                                {item.customTag && (
                                    <span className="menu-badge badge-custom">
                                        {item.customTag}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="menu-card-content">
                            <div className="menu-card-header">
                                <h3 className="menu-item-name">{item.name}</h3>
                                <span className="menu-price">{item.price}</span>
                            </div>

                            <p className="menu-description">{item.description}</p>

                            <div className="menu-card-footer">
                                <div className="menu-flavor-notes">
                                    <i className="fas fa-leaf"></i>
                                    <span>{item.flavorNote || 'Đậm đà, thơm ngon'}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Menu Bottom Note */}
            <div className="menu-footer-banner">
                <div className="menu-footer-text">
                    <i className="fas fa-seedling"></i>
                    <span>Tất cả cà phê tại <strong>Café 9</strong> đều là cà phê nguyên chất không tẩm ướp hoá chất, rang xay nguyên hạt.</span>
                </div>
            </div>
        </section>
    );
};

export default Menu;